import type { ComponentProps } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { FullscreenAlert, WarningCircleIcon } from "@/shared/ui";

export const DisqualifiedModal = ({
  open,
  onOpenChange,
}: ComponentProps<typeof FullscreenAlert.Root>) => {
  const navigate = useNavigate();

  const handleClose = () => {
    void navigate(ROUTES.HOME);
  };

  return (
    <FullscreenAlert.Root open={open} onOpenChange={onOpenChange}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={WarningCircleIcon}>
          <FullscreenAlert.Title>
            {t`We need to review your case`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Based on your current health condition, you are not eligible to take this medication at this time. We will contact you to cancel your order and process a full refund. We appreciate your understanding.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action onClick={handleClose}>
            {t`Back to Home`}
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
